"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfSendPropertyOwnerNotificationDataDto = instanceOfSendPropertyOwnerNotificationDataDto;
exports.SendPropertyOwnerNotificationDataDtoFromJSON = SendPropertyOwnerNotificationDataDtoFromJSON;
exports.SendPropertyOwnerNotificationDataDtoFromJSONTyped = SendPropertyOwnerNotificationDataDtoFromJSONTyped;
exports.SendPropertyOwnerNotificationDataDtoToJSON = SendPropertyOwnerNotificationDataDtoToJSON;
exports.SendPropertyOwnerNotificationDataDtoToJSONTyped = SendPropertyOwnerNotificationDataDtoToJSONTyped;
/**
 * Check if a given object implements the SendPropertyOwnerNotificationDataDto interface.
 */
function instanceOfSendPropertyOwnerNotificationDataDto(value) {
    if (!('notified' in value) || value['notified'] === undefined)
        return false;
    if (!('ownerId' in value) || value['ownerId'] === undefined)
        return false;
    return true;
}
function SendPropertyOwnerNotificationDataDtoFromJSON(json) {
    return SendPropertyOwnerNotificationDataDtoFromJSONTyped(json, false);
}
function SendPropertyOwnerNotificationDataDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'notified': json['notified'],
        'ownerId': json['ownerId'],
    };
}
function SendPropertyOwnerNotificationDataDtoToJSON(json) {
    return SendPropertyOwnerNotificationDataDtoToJSONTyped(json, false);
}
function SendPropertyOwnerNotificationDataDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'notified': value['notified'],
        'ownerId': value['ownerId'],
    };
}
